import { Button } from "react-bootstrap";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { useWindowSize } from "go-core/components/useWindowSize";
import { ReactComponent as RemoveSVG } from "go-core/images/svg/actions/remove.svg";
import FormNumberInput from "go-form/components/FormNumberInput";

export const BarcodesTable = ({ form }) => {
	const { t } = useTranslation();
	const { isSmallBreakpoint } = useWindowSize();
	const {
		control,
		register,
		formState: { errors },
	} = form;
	const { fields, append, remove } = useFieldArray({
		control,
		name: "barcodes",
	});

	return (
		<>
			<div className={`${isSmallBreakpoint ? "table-responsive" : ""}`}>
				<table className="table table-form vertical-top">
					<thead>
						<tr>
							<th className="action" />
							<th style={{ minWidth: isSmallBreakpoint ? "200px" : "unset" }}>
								{t("common.word.barcode")}
							</th>
							<th style={{ minWidth: isSmallBreakpoint ? "100px" : "unset" }}>
								{t("modules.product_package.field.net_weight.title")}
							</th>
							<th style={{ minWidth: isSmallBreakpoint ? "100px" : "unset" }}>
								{t("common.word.volume")}
							</th>
							<th className="action" />
						</tr>
					</thead>
					<tbody>
						{fields.map((field, index) => {
							const { id } = field;
							return (
								<tr key={id}>
									<td className="action" />
									<td>
										<FormInput
											name={`barcodes.${index}.barcode`}
											register={register}
											errors={errors}
										/>
									</td>
									<td>
										<FormNumberInput
											name={`barcodes.${index}.net_weight`}
											control={control}
											errors={errors}
											suffix=""
										/>
									</td>
									<td>
										<FormNumberInput
											name={`barcodes.${index}.volume`}
											control={control}
											errors={errors}
											suffix=""
										/>
									</td>
									<td className="action">
										<RemoveSVG className="icon" onClick={() => remove(index)} />
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			<Button
				className="mb-3"
				onClick={() => append({ barcode: "", net_weight: undefined, volume: undefined })}
			>{`+ ${t("common.action.add", { ns: "lib" })}`}</Button>
		</>
	);
};
